import StandModel                     from '@/models/services/website/StandModel';
import StandPageValidationStatusModel from '@/models/services/website/StandPageValidationStatusModel';
import WebsiteServiceModel            from '@/models/WebsiteServiceModel';
import doc                            from '@widesk-core/decorators/doc';

export default class StandPageModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'stand': id;
		'stand.websiteEntertainment': id;
		'stand.exhibitor': id;
		'standPageValidationStatus': string;
		'stand.slug': id;
	};

	private declare _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
		standPageValidationStatus: string;
	};

	static get path(): string {
		return 'stand_pages/{?id}';
	}

	@doc.model(StandModel) declare stand: StandModel;
	@doc.model(StandPageValidationStatusModel) declare standPageValidationStatus: StandPageValidationStatusModel;

	getTitle(lang: string) {
		return this.getTranslation<string, string>(`title`, lang, '');
	}

	getExcerpt(lang: string) {
		return this.getTranslation<string, string>(`excerpt`, lang, '');
	}

	getContent(lang: string) {
		return this.get<string, string>(`translations.${lang}.content`, '');
	}

	get isDisabled(): boolean {
		return this.standPageValidationStatus?.reference === 'DISABLED';
	}

	get isInCreation(): boolean {
		return this.standPageValidationStatus?.reference === 'IN_CREATION';
	}

	get isRefused(): boolean {
		return this.standPageValidationStatus?.reference === 'REFUSED';
	}

	get isValidated(): boolean {
		return this.standPageValidationStatus?.reference === 'VALIDATED';
	}

	get isValidationRequested(): boolean {
		return this.standPageValidationStatus?.reference === 'VALIDATION_REQUESTED';
	}
}
